<template>
  <tr>
    <td>
      <div class="c-product-card type-horizontal type-checkbox">
        <div class="c-checkbox type-small">
          <input
            type="checkbox"
            :id="'recent-history-chk-' + data.product.idntyPrdctSn"
            name="recent-history-chk-group"
            :checked="data.product.chk"
            @change="btnCmd('checkClick')"
          />
          <label :for="'recent-history-chk-' + data.product.idntyPrdctSn">
            <span class="sr-only">상품선택</span>
          </label>
        </div>
        <div class="product-thumb">
          <button
            type="button"
            class="thumb-button"
            @click="() => emits('select', data.product)"
          >
            <div class="product-img">
              <img
                v-if="isNoPcImage"
                src="@/assets/images/common/img_no_product.svg"
                alt="No Image"
                class="no-image"
              />
              <img
                v-else
                :src="imageFilePath"
                alt=""
                @error="() => (imageErrorYn = true)"
              />
            </div>
            <div class="thumb-bottom">
              <p class="text">제품상세</p>
              <i class="c-icon icon-plus"></i>
            </div>
          </button>
        </div>
        <div class="product-info">
          <div class="c-product-badge">
            <span
              v-show="data.product.setgdYn === 'Y'"
              class="badge type-skyblue"
            >
              SET 제품
            </span>
            <span v-if="data.product.zzlqdCls == 'A'" class="badge type-purple">
              주제
            </span>
            <span v-if="data.product.zzlqdCls == 'B'" class="badge type-mint">
              경화제
            </span>
            <span v-if="data.product.zzlqdCls == 'C'" class="badge type-blue">
              경화촉진제
            </span>
            <span v-if="data.product.zzlqdCls == 'D'" class="badge type-violet">
              회석제
            </span>
            <span
              v-if="data.product.zzlqdtyCls == 'A'"
              class="badge type-olive"
            >
              1액형
            </span>
            <span
              v-if="data.product.zzlqdtyCls == 'B'"
              class="badge type-olive"
            >
              2액형
            </span>
            <span
              v-if="data.product.zzlqdtyCls == 'C'"
              class="badge type-olive"
            >
              3액형
            </span>
          </div>
          <div class="c-product-category">
            <span class="path"> {{ data.product.prodh1t }} </span>
            <span class="path"> {{ data.product.prodh2t }} </span>
            <span class="path"> {{ data.product.prodh3t }} </span>
          </div>
          <div class="product-code">{{ data.product.matnr }}</div>
          <strong class="product-name"> {{ data.product.zzmaktx }} </strong>
        </div>
      </div>
    </td>
    <td class="ac">{{ data.product.zztotalQty }}</td>
    <td class="ac">
      <div class="c-counter">
        <button
          type="button"
          class="btn-minus"
          @click="() => data.product.qty--"
          :disabled="data.product.qty <= 1"
        >
          <i class="c-icon icon-minus size-xxsmall"></i>
          <span class="sr-only">빼기</span>
        </button>
        <input
          type="number"
          title="수량입력"
          v-model="data.product.qty"
          @blur="() => prodCounterChange()"
          ref="myInput"
          @mousedown="handleMouseDown"
        />
        <button
          type="button"
          class="btn-plus"
          @click="() => data.product.qty++"
        >
          <i class="c-icon icon-plus-black size-xxsmall"></i>
          <span class="sr-only">더하기</span>
        </button>
      </div>
    </td>
    <td class="ar">{{ Utils.currency(totalPrice) }}원</td>
    <!-- 2025-01-01 추가 -->
    <td class="ac">
      <div class="button-box">
        <button
          type="button"
          class="c-util-button type-line-black type-small"
          @click="() => emits('cart', { ...data.product })"
        >
          <span>장바구니</span>
        </button>
        <button
          type="button"
          class="c-util-button type-primary type-small"
          @click="() => emits('buy', { ...data.product })"
        >
          <span>바로주문</span>
        </button>
      </div>
    </td>
  </tr>
</template>
<script setup>
import {
  onMounted,
  defineProps,
  defineEmits,
  computed,
  reactive,
  watch,
  ref,
} from "vue";
import Utils from "@/js/utils";
import * as cmUtil from "@/utils/cmUtil";

const FILE_CDN_URL = process.env.VUE_APP_FILE_CDN_URL;
const imageErrorYn = ref(false);
const myInput = ref(null);

const props = defineProps({
  product: {
    type: Object,
    require: true,
  },
});

const emits = defineEmits(["buy", "cart", "select", "delete"]);

const data = reactive({
  product: {},
});

const totalPrice = computed(() => {
  return data.product.qty * data.product.kbetr;
});

onMounted(() => {
  data.product = props.product;
});

const isNoPcImage = computed(() => {
  return (
    Utils.isBlank(data.product.imgFilePath) ||
    Utils.isBlank(data.product.imgFileNm) ||
    imageErrorYn.value
  );
});

const imageFilePath = computed(() => {
  return (
    FILE_CDN_URL + "/" + data.product.imgFilePath + "/" + data.product.imgFileNm
  );
});

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(cmd = "", parms = {}) {
  if (cmd === "plusClick") {
    this.data.product.qty++;
  } else if (cmd === "minusClick") {
    if (this.data.product.qty == 1) {
      cmUtil.alert("최소 수량은 1개입니다.<br>0은 입력할 수 없습니다.");
    } else if (this.data.product.qty > 0) {
      this.data.product.qty--;
    }
  } else if (cmd === "checkClick") {
    this.data.product.chk = !this.data.product.chk;
  } else {
    alert(
      `[개발확인] recentlyViewedProdItem btnCmd() cmd [${cmd}] 를 확인해주세요` +
        JSON.stringify(parms, null, " ")
    );
    return false;
  }
}

// 상품 카운터 변경
async function prodCounterChange() {
  if (data.product.qty === 0 || data.product.qty === "") {
    await cmUtil.alert("최소 수량은 1개입니다.<br>0은 입력할 수 없습니다.");
    data.product.qty = 1;
    return;
  }
}

watch(
  () => data.product.qty,
  (newQty, oldQty) => {
    if (newQty < 1) {
      data.product.qty = 1;
    } else if (newQty > 99999) {
      data.product.qty = oldQty;
    } else {
      data.product.qty = newQty;
    }
  }
);
const handleMouseDown = (event) => {
  event.preventDefault();
  myInput.value?.focus();
  myInput.value?.select();
};
</script>
